import { TableContainer } from "@material-ui/core";
import { Link } from "react-router-dom";
import styled, { FlattenSimpleInterpolation, createGlobalStyle, css } from "styled-components";
import { FomrmLoginInput } from "../../LoginUser/styled/LoginStyles";

export const PersonalInforPageWrap = styled.div`
	    width: 540px;
    position: relative;
    margin: 0 auto 0;
     padding: 24px 0 80px;
    max-width: 1440px;
    // display: flex;
    font-size:16px;
    justify-content: space-between;
    @media screen and (max-width: 768px) {
		margin: 0;
    width: 100%;
    padding: 16px;
    height: inherit;
	    align-items: center;
   
}
	}
`;
export const PersonInfoPageNavigationPageWrap = styled.div`
    width: 1200px;
    position: relative;
    margin: auto;
    max-width: 1440px;
    display: flex;
    font-size:16px;
    justify-content: space-between;
    @media screen and (max-width: 768px) {
		margin: 0;
    width: 100%;
    padding: 16px 16px 0;
    height: inherit;
	    align-items: center;
   
}
	}
`;

export const PersonInfoContentName = styled.div`
	color: #111827;
	font-size: 24px;
	font-weight: 600;
	line-height: 28px;
	margin-bottom: 24px;
	@media screen and (max-width: 768px) {
		margin-bottom: 8px;
	}
`;

export const PersonInfoSetPageWrap = styled.div`
	display: flex;
	@media screen and (max-width: 768px) {
	}
`;

export const PersonInfoSetPage = styled.div<{ isSelected: boolean }>`
	color: ${({ isSelected }) => (isSelected ? "#035D9D" : "#6B7280")};
	border-bottom: 1px solid ${({ isSelected }) => (isSelected ? "#035D9D" : "none")};
	font-size: 14px;
	font-style: normal;
	font-weight: 600;
	line-height: 20px;
	margin-right: 20px;
	margin-bottom: 24px;
	display: flex;
	height: 44px;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	cursor: pointer;

	@media screen and (max-width: 768px) {
	}
`;

export const PersonInfoBackground = styled.div`
	background-color: #fff;
	border-radius: 16px;
	padding: 24px;
`;

export const PersonUpdateInfoWrap = styled.div``;
export const PersonUpdateInfoAvatarWrap = styled.div`
	margin-bottom: 16px;
`;
export const PersonUpdateInfoAvatarName = styled.div`
	color: #111827;
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	margin-bottom: 16px;
`;
export const PersonUpdateInfoAvatarImgWrap = styled.div`
	display: flex;
`;
export const PersonUpdateInfoAvatarImg = styled.img`
	width: 44px;
	height: 44px;
	border-radius: 100px;
	margin-right: 8px;
`;
export const PersonUpdateInfoAvatarButtonUpload = styled.button`
	display: flex;
	padding: 12px 16px;
	justify-content: center;
	align-items: center;
	border-radius: 8px;
	border: 1px solid #e5e7eb;
	background: #fff;
	width: 150px;
`;
export const PersonUpdateInfoOrtheWrap = styled.div``;
export const PersonUpdateInfoOrtheFormLoginWrap = styled.div`
	border-radius: 8px;
	border: 1px solid #d1d5db;
	padding: 8px 16px;
	margin-bottom: 16px;
`;
export const PersonUpdateInfoOrtheFormLogin = styled(FomrmLoginInput)`
	width: calc(100% - 8px);
	display: inline-block;
	&:first-child {
		margin-right: 16px;
	}
	border: none;
	margin-bottom: 0;
	height: auto;
	padding: 0;
	&:focus {
		outline: none;
	}
	@media screen and (max-width: 768px) {
		width: 100%;
	}
`;
export const PersonUpdateInfoButtonSave = styled.button<{ $loading?: boolean }>`
	display: flex;
	width: 100px;
	padding: 8px 16px;
	justify-content: center;
	align-items: center;
	border-radius: 8px;
	color: #fff;
	cursor: ${({ $loading }) => ($loading ? "not-allowed" : "pointer")};
	background: ${({ $loading }) => ($loading ? "#cccccc" : "#035D9D")};
	opacity: ${({ $loading }) => ($loading ? 0.6 : 1)};
	pointer-events: ${({ $loading }) => ($loading ? "none" : "auto")};
	border: none;
`;
export const PartnerbuttonRemoteImage = styled.button`
	position: absolute;
	top: -5px;
	right: -5px;
	background-color: red;
	color: white;
	border: none;
	borderRadius: 50%;
	width: 20px;
	height: 20px;
	cursor: pointer;
	border-radius: 8px;

	`;
export const PartnerImageWrap = styled.div`
 display: flex;
 flex-wrap: wrap;
 margin-top: 10px;
	`;
export const PartnerImage = styled.img`
width: 100px;
height: 100px; 
object-fit: cover; 
border-radius: 8px;
	`;
export const PartnerImageInner = styled.div`
position: relative;
margin-right: 10px;
	`;
